module.exports = __webpack_public_path__ + "img/portrait-007.ab3a7bdd.jpg";